<template>
  <div>
    <transition appear mode="out-in">
      <div id="overlay">
        <div id="content" v-on:click="stopEvent">
          <div>
            <h3 class="confirmation-title">
              {{ confirmation_title }}
            </h3>
            <p class="confirmation-top-msg">
              <span class="top-msg-text">
                {{ confirmation_top_msg }}
              </span>
            </p>
            <ul class="confirmation-msg">
              <li
                v-for="confirmation_warn in confirmation_warn_list"
                v-bind:key="confirmation_warn.msg"
              >
                {{ confirmation_warn.msg }}
              </li>
            </ul>
            <slot />
            <button
              style="width: 120px; margin-top: 20px"
              v-on:click="okEvent"
              class="btn btn-outline-secondary float-right btn-action"
              type="button"
            >
              OK
            </button>
            <button
              style="width: 120px; margin-top: 20px"
              v-on:click="cancelEvent"
              class="btn btn-outline-secondary float-right btn-action"
              type="button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faCopy, faCheckCircle);
Vue.component("font-awesome-icon", FontAwesomeIcon);

export default {
  name: "confirmation-modal",
  props: {
    confirmation_title: String,
    confirmation_top_msg: String,
    confirmation_warn_list: Array
  },
  data() {
    return {
      confirm_msg: "",
      logger: this.$store.state.logger
    };
  },
  created() {},
  methods: {
    cancelEvent: function () {
      this.$emit("confirm-cancel");
    },
    okEvent: function () {
      this.$emit("confirm-ok");
    },
    stopEvent: function () {
      event.stopPropagation();
    },
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.announce_msg)
        .then(() => {
          console.log("copied!");
          this.isMsgCopy = true;
          setTimeout(this.clearCopyFlag, 2000);
        })
        .catch((e) => {
          console.error(e);
        });
    },
    clearCopyFlag() {
      this.isMsgCopy = false;
    }
  },
  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>

<style scoped>
.sharing-msg-box {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding: 15px;
}

.top-msg-text {
  vertical-align: middle;
}

.confirmation-msg {
  color: red;
}

.confirmation-title {
  margin-bottom: 15px;
}

.share-msg-copy-btn {
  margin-left: 10px;
}

.share-msg-copy-icon {
  margin-right: 5px;
  margin-left: 5px;
}

.copy-complete-msg {
  margin-left: 15px;
  color: #adb5bd;
  vertical-align: middle;
}

#content {
  z-index: 10001;
  width: 700px;
  max-height: 95vh;
  padding: 1.5em;
  background: #fff;
  border-radius: 0.75em;
}

.btn-action {
  width: 120px;
  margin-top: 20px;
  margin-left: 10px;
}

#overlay {
  /*　要素を重ねた時の順番　*/
  z-index: 10000;

  /*　画面全体を覆う設定　*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  /*　画面の中央に要素を表示させる設定　*/
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

/* タブレット向け */
@media screen and (min-width: 671px) and (max-width: 1240px) {
  h3 {
    font-size: 1.5em;
  }
}

/* スマホ向け */
@media screen and (max-width: 670px) {
  #content {
    width: 90%;
  }

  h3 {
    font-size: 1.25em;
  }

  .confirmation-top-msg {
    font-size: 1em;
  }

  .btn-action {
    width: 45% !important;
  }
}
</style>
